import { defineStore } from 'pinia';
import {getInfo} from '@/api/requestApi.js'

export const useUserStore = defineStore('user', {
  state: () => ({
    userData: {},//用户数据
    userName: '',//员工号
    jgbm: '',//机构编码
    rolesList: [],//角色权限
    getUserInfo: {}
  }),
  actions: {
    setUserData(data) {
        this.userData = data.user;
        this.userName = data.user?.userName;
        this.jgbm = data.user?.jgbm;
    },
    // 获取用户信息
    async getInfo() {
        let that = this
      return await getInfo().then((res) => {
        let data = res.data
        that.getUserInfo = data
        that.userData = data.user;
        that.userName = data.user?.userName;
        that.jgbm = data.user?.jgbm;
        that.rolesList = data?.user?.roles || [];
        localStorage.setItem('userData', JSON.stringify(data)) //用户数据
        localStorage.setItem('userName', that.userName)//员工号
        localStorage.setItem('jgbm', that.jgbm)//机构编码
        console.log('用户信息', that.userData, that.userName, that.jgbm)
        return res
        }).catch((error) => {});
    },
    //角色权限
    setRoles(rolesName) {
      let that = this
      return that.rolesList.find((item) => item.roleKey == rolesName)
    }
  },
  persist: true
});
